import { ILenderRequest } from 'modules/Lender/types/Lender.types';

export const getHashTableIdByLenderName = (lendersHashTable: Record<string, ILenderRequest>, lenderName: string) =>
  Object.keys(lendersHashTable).find((id) => lendersHashTable[id].name === lenderName) || null;

export const getHashTableIdByLenderId = (lendersHashTable: Record<string, ILenderRequest>, lenderId: number) =>
  Object.keys(lendersHashTable).find((id) => lendersHashTable[id].id === lenderId) || null;
